module.exports = __webpack_public_path__ + "static/media/sidebar-nmt.c61558ec.jpg";